import brandsJson from '@/content/brands.json';
import type { Brand, PetType } from '@/types/catalog';

/**
 * Marcas distribuídas pela BrucePets.
 *
 * Dados em `src/content/brands.json`, editáveis pelo painel em /admin.
 * As cores reproduzem o par reconhecível de cada marca mantendo contraste de
 * texto em 4.5:1 — os tiles são tipográficos, então nada aqui depende de
 * direitos sobre artes de terceiros.
 */
export const BRANDS = brandsJson as Brand[];

/** O(1) lookup by id. Built once at module load. */
const BRANDS_BY_ID = new Map(BRANDS.map((brand) => [brand.id, brand]));

export function getBrand(id: string): Brand | undefined {
  return BRANDS_BY_ID.get(id);
}

/**
 * Brand name for display. Falls back to the raw id so a typo in the product
 * data surfaces visibly instead of rendering an empty label.
 */
export function getBrandName(id: string): string {
  return BRANDS_BY_ID.get(id)?.name ?? id;
}

export function getBrandsForPet(petType: PetType): Brand[] {
  return BRANDS.filter((brand) => brand.petTypes.includes(petType));
}
